import React from 'react';
import { CheckCircle } from 'lucide-react';

export function SignatureSuccessPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-8 h-8 text-green-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Signature Complete!
        </h1>
        
        <p className="text-gray-600 mb-6">
          Thank you for signing the agreement. Your signature has been successfully recorded.
        </p>
        
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
          <h2 className="font-medium text-gray-900 mb-2">What happens next?</h2>
          <p className="text-sm text-gray-600">
            You will receive a confirmation email with a copy of the fully executed agreement once all parties have signed.
            No further action is required from you at this time.
          </p>
        </div>
        
        <div className="flex justify-center">
          <a
            href="https://searchproperty.com.au"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium transition-colors duration-200"
          >
            Return to Search Property
          </a>
        </div>
      </div>
    </div>
  );
}